import React, { useState, useEffect } from "react";
import Select from "react-select";
import CustomMenuList from "./CustomMenuList";

const ScrollPagination = ({
	Service,
	setData,
	value = "",
	isMulti = false,
	nameVal,
}) => {
	const [options, setOptions] = useState([]);
	const [page, setPage] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const [inputValue, setInputValue] = useState("");

	const fetchOptions = async (reset = false) => {
		const currentPage = reset ? 1 : page;

		try {
			let params = {
				offset: currentPage,
				limit: 10,
			};
			if (!!inputValue) params["search"] = inputValue;
			await Service.getList({ ...params }).then((res) => {
				if (res?.status) {
					let response = res?.data?.data;
					let items = response?.map((emp) => {
						return {
							...emp,
							label: emp[nameVal],
							value: emp?.id,
						};
					});
					setOptions((prev) => (reset ? items : [...prev, ...items]));
					setHasMore(res?.data?.totalPages !== currentPage);
					setPage(currentPage + 1);
				}
			});
		} catch (error) {
			console.error("Error loading: ", error);
		}
	};

	// Refetch when search changes
	useEffect(() => {
		const timeout = setTimeout(() => {
			setPage(1);
			fetchOptions(true);
		}, 300); // Debounce search

		return () => clearTimeout(timeout);
	}, [inputValue]);

	return (
		<Select
			options={options}
			components={{ MenuList: CustomMenuList }}
			onScrollToBottom={() => hasMore && fetchOptions()}
			onInputChange={(value) => setInputValue(value)}
			inputValue={inputValue}
			value={value}
			isMulti={isMulti}
			placeholder="Select"
			isClearable
			onChange={(e) => setData(e)}
		/>
	);
};
export default ScrollPagination;
